import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateContractAssetStatus } from "src/store/contract-asset-status/saga";
import { ContractAssetStatusDetailDto } from "src/store/contract-asset-status/type";
import * as Yup from "yup";

const ContractAssetStatusEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ContractAssetStatusDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.AssetStatus.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Title: x.Name,
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateContractAssetStatus({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Contract.AssetStatus.Name").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ContractAssetStatusEditForm;
